import { MARQUEE_ITEMS } from '../content/siteContent';

export default function Marquee() {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-[#050505] py-6 md:py-8"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span
                  className={`whitespace-nowrap px-8 font-display text-3xl font-semibold tracking-tight md:text-5xl ${
                    i % 2 === 0 ? 'text-white/90' : 'text-outline'
                  }`}
                >
                  {item}
                </span>
                <span className="h-2 w-2 rounded-full bg-[#47a0d9]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
